<template>
  <div class="flex justify-center">
    <iframe width="640" height="360" :src="videoLink" />
  </div>
</template>

<script setup lang="ts">
import type { Video } from '@/types/contentful';

type VideoRestApi = {
  fields?: {
    videoLink: string;
  };
};

type Props = {
  content: VideoRestApi | Video;
};

const props = defineProps<Props>();

const videoLink = computed(
  () => (props.content as Video)?.videoLink || (props.content as VideoRestApi).fields?.videoLink,
);
</script>

<script lang="ts">
export default defineComponent({
  name: 'ContentfulVideo',
});
</script>
